/**
 * Hook to cleanup CSRF tokens on sign-out
 *
 * Listens to Clerk sign-out events and clears CSRF tokens
 */

import { useEffect } from 'react';
import { useClerkGate } from '@/hooks/useClerkGate';
import { clearCSRFToken } from '@/lib/csrf';

export function useCSRFCleanup() {
  const { isSignedIn } = useClerkGate();

  useEffect(() => {
    // Clear CSRF token when user signs out
    if (!isSignedIn) {
      clearCSRFToken();
    }
  }, [isSignedIn]);
}
